import { InvoiceTotalPriceColumns } from '@features/invoices/enums/invoiceTotalPriceColumns'
import { getInvoiceTotalPriceColumns } from '@features/invoices/utils/getInvoiceTotalPriceColumns'

import type { ZervantSettingsFields } from '../../../types/zervantSettingsFields'
import type { FieldInterface } from '../../../types/zervantSettingsModel'
import type { DocumentTypeSettingsFormValues } from '../types/documentTypeSettingsFormValues'
import { getDocumentTypeSettingsColumnNames } from './getDocumentTypeSettingsColumnNames'

export interface DocumentTypeSettingsDefaultTexts {
  footerNote: string
  message: string
}

const emptyDefaultTexts: DocumentTypeSettingsDefaultTexts = { footerNote: '', message: '' }

// An empty or missing message and footer note show the translated default, like the old settings page
// and the editor. Saving is safe because the patch only carries the fields the user changed.
const getStoredText = (field: FieldInterface | undefined, defaultText = ''): string => {
  return field?.default || defaultText
}

export const getDocumentTypeSettingsFormValues = (
  fields: ZervantSettingsFields,
  defaultTexts: DocumentTypeSettingsDefaultTexts = emptyDefaultTexts,
): DocumentTypeSettingsFormValues => {
  const columnNames = getDocumentTypeSettingsColumnNames(fields)

  return {
    footerNote: getStoredText(fields.footerText, defaultTexts.footerNote),
    isDateColumnVisible: columnNames.includes('date'),
    isUnitColumnVisible: columnNames.includes('unit'),
    message: getStoredText(fields.description, defaultTexts.message),
    shouldShowTermsAndConditions: fields.legalterms?.visible ?? false,
    termsAndConditions: getStoredText(fields.legalterms),
    totalPriceColumns: getInvoiceTotalPriceColumns(columnNames) ?? InvoiceTotalPriceColumns.Gross,
  }
}
